const AllBookingExtentionRequestReducer = (
  state = { loader: false, result: [], error: null },
  action
) => {
  switch (action.type) {
    case "ALL_BOOKING_EXTENTION_LIST_BEGINS":
      return {
        loader: true,
        result: {},
        error: null,
      };
    case "ALL_BOOKING_EXTENTION_LIST_SUCCESS":
      return {
        loader: false,
        result: action.payload,
        error: null,
      };
    case "ALL_BOOKING_EXTENTION_LIST_FAILURE":
      return {
        loader: false,
        result: {},
        error: action.payload,
      };
    case "ALL_BOOKING_EXTENTION_LIST_RESET":
      return {
        loader: false,
        result: [],
        error: null,
      };
    default:
      return state;
  }
};

export default AllBookingExtentionRequestReducer;
